import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BasespaceService } from '@bssh/ng-sdk';
import { Observable } from 'rxjs';
import { delay, retryWhen } from 'rxjs/operators';
import { BulkUpdateResponse } from '../../bsshapi/api-wrappers';
import IResource from '../../model/resource';
import { IUser } from '../../model/user';
import { IApiResponseWrapper } from '../../model/v2-api/v2-api-wrappers';
import { genericRetryWhen, observableEmitDelay } from '../../rxjsutils/rxjs-utilities';
import { BsApiEndPoints } from '../bs-api/endpoints';
import { CodeFeaturesService } from '../user/code-features.service';
import { UserSubscriptionService } from '../user/user-subscription.service';
import { isNullOrUndefined } from 'util';

// Interface for the service.
export interface IArchiveService {
  canArchive(resources: IResource[], user: IUser): boolean;
  archive(runIds: Array<string>, datasetIds: Array<string>): Observable<IApiResponseWrapper<BulkUpdateResponse>>;
}

@Injectable({
  providedIn: 'root'
})
export class ArchiveService implements IArchiveService {

  constructor(private codeFeaturesService: CodeFeaturesService,
              private userSubscriptionService: UserSubscriptionService, private httpClient: HttpClient) { }

  public canArchive(resources: IResource[], user: IUser): boolean {
    // TODO: toalsize, isDeleted, isFileDataDeleted are checked before actual action in old code.
    // https://git.illumina.com/BaseSpace/basespace/blob/develop/src/Tang.Modules/Modals/Archive/archiveV2Modal.directive.ts#L209
    // Should we include it here?

    if (isNullOrUndefined(resources) || isNullOrUndefined(user)) {
      return false;
    }

    // Allow archiving in personal context only if 'Archiving' Code feature allows it.
    if (!this.codeFeaturesService.archivingIsEnabled
      || !this.userSubscriptionService.hasCommercialSubscription()) {
      return false;
    }

    return resources.some(resource => !isNullOrUndefined(resource)  && !resource.IsArchived && resource.UserOwnedBy &&
      resource.UserOwnedBy.Id === user.Id);

  }

  public archive(runIds: Array<string>, datasetIds: Array<string>): Observable<IApiResponseWrapper<BulkUpdateResponse>> {

    const postData = { RunIds: runIds, DatasetIds: datasetIds };
    return this.httpClient.post<IApiResponseWrapper<BulkUpdateResponse>>(BsApiEndPoints.ARCHIVE_URL, postData).pipe(
      // Retry in case of HTTP errors
      retryWhen(genericRetryWhen()),
      // To avoid a Flash of content, maintain a delay
      delay(observableEmitDelay),
    );
    // return this.basespaceApi.PostV2Archive({ RunIds: runIds, DatasetIds: datasetIds, Id: null });
  }
}
